import { computed, Ref } from '@nuxtjs/composition-api';
import { IBreakpoint } from '@shared/types/IBreakpoint';

import { IConfig } from '../types';

export const defaultConfig: IConfig = {
  cardMode: 'wrap',
  cardSpacing: '16px',
  cardFlexBasis: '100%',
  cardFlexGrow: 0,
  headerStyle: {},
  titleStyle: {},
  groupStyle: {},
  showDescription: true,
  showSteppers: false,
  paddingBottom: '8px',
  peek: false,
};

const useFlattenedConfig = (props: any, breakpoint: Ref<IBreakpoint>) => {
  const config = computed(() => {
    const mobile = { ...defaultConfig, ...(props.mobile || {}) };
    const tablet = { ...mobile, ...(props.tablet || {}) };
    const desktop = { ...tablet, ...(props.desktop || {}) };

    switch (breakpoint.value.name) {
      case 'desktop':
        return desktop;
      case 'tablet':
        return tablet;
      case 'mobile':
      default:
        return mobile;
    }
  });

  return { config };
};

export default useFlattenedConfig;
